import React from 'react';
import ReactDOM from 'react-dom/client';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Home from '../../Home/Home';
import ContestAll from '../ContestAll';
import 'bootstrap/dist/css/bootstrap.min.css';
import Contest from '../Contest';
import CodeForces from '../Codeforces';
import Codechef from '../Codechef';
import Leetcode from '../Leetcode';
import Atcoder from '../Atcoder';
import Topcoder from '../Topcoder';
import Google from '../Google';
import Hackerearth from '../Hackerearth';
import Hackerrank from '../Hackerrank';
import Dsa from '../Dsa';
import Contact from '../../Contact/Contact';
// import Home from '../../Home/Home';
import {
    BrowserRouter,
    Routes,
    Route,
    Link,
  } from "react-router-dom";




function Front(){
    
    return (
        <BrowserRouter>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>
            <div className='one codechef'>
            Front <span ><Link className='visit' to="/" >Front explore</Link></span>
          </div>


            <div>
            <Routes>
            
         </Routes>
            </div>
            </BrowserRouter>
    )
}
export default Front;
